import { render, staticRenderFns } from "./CollegiateFilters.vue?vue&type=template&id=3408b768&scoped=true&"
import script from "./CollegiateFilters.vue?vue&type=script&lang=js&"
export * from "./CollegiateFilters.vue?vue&type=script&lang=js&"
import style0 from "./CollegiateFilters.vue?vue&type=style&index=0&id=3408b768&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3408b768",
  null
  
)

export default component.exports